import React, { useEffect } from "react";
import BookingStats from "./BookingStats";
import DoctorSlots from "./DoctorSlots";
import CardDiv from "modules/common/card-div/CardDiv";
import { fourPlaceHolder } from "modules/utilities/utility";

function ListView({
  status,
  setStatus,
  setTabType,
  doctorSlots,
  setDoctorsFilter,
  setPaymentFilter,
  setStartFilterDate,
  isLoading
}) {
  return (
    <div>
      {doctorSlots && Object?.keys(doctorSlots).length ? (
        <>
          <BookingStats stats={doctorSlots.stats} />
          <DoctorSlots
            status={status}
            setStatus={setStatus}
            slots={doctorSlots.slots}
            doctors={doctorSlots.doctors}
            setPaymentFilter={setPaymentFilter}
            setStartFilterDate={setStartFilterDate}
            setDoctorsFilter={setDoctorsFilter}
            isLoading={isLoading}
          />
        </>
      ) : (
        <div className="w-100">
          <CardDiv
            title={<h5>Doctor Slots</h5>}
            component={<div>{fourPlaceHolder()}</div>}
          />
        </div>
      )}
    </div>
  );
}

export default ListView;
